import * as React from "react"
import { Route, Switch } from "react-router-dom"
import useSession from "@digits-shared/hooks/useSession"
import AnalysisApplication from "src/frontend/components/OS/Applications/Analysis/AnalysisApplication"
import { InviteClientModal } from "src/frontend/components/OS/Applications/ClientPortal/InviteFlow/InviteClientModal"
import { DigitsWelcomeModal } from "src/frontend/components/OS/Applications/Home/DigitsWelcomeModal"
import { HomeApplicationHeader } from "src/frontend/components/OS/Applications/Home/HomeApplicationHeader"
import { HomeApplicationHeaderMobile } from "src/frontend/components/OS/Applications/Home/HomeApplicationHeader.mobile"
import { HomeLayout } from "src/frontend/components/OS/Applications/Home/HomeLayout"
import { ApplicationFullWidthPane } from "src/frontend/components/OS/Chrome/Desktop/ApplicationPane"
import { PortalLayoutProvider } from "src/frontend/components/Shared/Portals/Layout/PortalLayoutProvider"
import { useInviteClientsModalControls } from "src/frontend/components/Shared/Portals/State/useInviteClientsModalControls"
import { Desktop } from "src/frontend/components/Shared/Responsive/Desktop"
import { Mobile } from "src/frontend/components/Shared/Responsive/Mobile"
import routes from "src/frontend/routes"
import type FrontendSession from "src/frontend/session"

/*
  STYLES
*/

/*
 COMPONENTS
*/

export const HomeApplication: React.FC<React.PropsWithChildren> = () => {
  const { isSharingContextActive, hasDashboardLegalEntityOrAffiliation, currentLegalEntity } =
    useSession<FrontendSession>()
  if (!currentLegalEntity) return null

  /* Need to ensure a legal entity to handle loading support for Digits Employees */
  if (!hasDashboardLegalEntityOrAffiliation || isSharingContextActive) {
    return null
  }

  return (
    <PortalLayoutProvider>
      <Desktop>
        <ApplicationFullWidthPane>
          <HomeApplicationHeader />
          <HomeContents />
        </ApplicationFullWidthPane>
        <DigitsWelcomeModal />
      </Desktop>

      <Mobile>
        <HomeApplicationHeaderMobile />
        <HomeContents />
      </Mobile>
    </PortalLayoutProvider>
  )
}

const HomeContents: React.FC = () => {
  const { shouldShow: showInviteClientModal, hideModal } = useInviteClientsModalControls()

  return (
    <>
      {showInviteClientModal && (
        <InviteClientModal showViewUsers onClose={hideModal} onDone={hideModal} />
      )}

      <Switch>
        {/* Analysis */}
        <Route
          path={[routes.expenses.parameterizedPath, routes.revenue.parameterizedPath]}
          component={AnalysisApplication}
        />

        <Route path={routes.legalEntityHome.parameterizedPath} component={HomeLayout} />
      </Switch>
    </>
  )
}
